export default "__VITE_ASSET__DLS3Gw6X__"